import { VideoBoxComponent } from "front-end/components/video-box/video-box.component";
import { Subscription } from "rxjs";
import { IBannerDetailsMediaComponent } from "../banner-details-media.component";

export class VideoComponent implements IBannerDetailsMediaComponent {
    private _currentContext: JQuery = $();

    private _videoBox: VideoBoxComponent = null;
    private _onVideoPlayerReady: Subscription = null;

    private parseContext(): void {
        const videoBox = $(VideoBoxComponent.SELECTOR, this._currentContext);
        this._videoBox = new VideoBoxComponent();
        this._onVideoPlayerReady = this._videoBox.on("ready")
            .subscribe(() => this._videoBox.playVideo());
        this._videoBox.init(videoBox);
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
    }

    public dispose(): void {
        if (this._onVideoPlayerReady) {
            this._onVideoPlayerReady.unsubscribe();
        }
        if (this._videoBox) {
            this._videoBox.destroy();
        }
    }
}
